import { render, staticRenderFns } from "./ModalEditNickname.vue?vue&type=template&id=83052d0c&"
import script from "./ModalEditNickname.vue?vue&type=script&lang=js&"
export * from "./ModalEditNickname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports